// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Source_Sans_3_86b611', '__Source_Sans_3_Fallback_86b611'"},"className":"__className_86b611"};